import { createStore as createReduxStore, applyMiddleware, compose } from 'redux';
import rootReducer from './root-reducer';

import { createEpicMiddleware } from 'redux-observable';
import { RootAction, RootState, Services } from 'typesafe-actions';

import rootEpic from './root-epic';
import services from '../services';

const composeEnhancers =
  (process.env.NODE_ENV === 'development' &&
    window &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

export const epicMiddleware = createEpicMiddleware<
  RootAction,
  RootAction,
  RootState,
  Services
>({
  dependencies: services
});

const middlewares = [epicMiddleware];  
const enhancer = composeEnhancers(applyMiddleware(...middlewares));

export function createStore () {
  const store = createReduxStore(rootReducer, {}, enhancer);
  epicMiddleware.run(rootEpic);
  return store;
}